import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  modalContent: {
    position: "relative",
    maxHeight: "95vh",
    overflowY: "auto",
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2),
    margin: "0 auto",
    maxWidth: [theme.breakpoints.values.xl],
    [theme.breakpoints.down("lg")]: {
      margin: "0 20px",
    },
  },
  textHeader: {
    fontSize: "1.5rem",
    fontWeight: 700,
    textAlign: "center",
    marginBottom: theme.spacing(2),
  },
  iconHeader: {
    position: "absolute",
    top: theme.spacing(2),
    right: theme.spacing(2),
    color: theme.palette.text.secondary,
    "&:hover": {
      color: theme.palette.quizResults.incorrect.main,
    },
  },
  courseInfoContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  courseInfo: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    color: theme.palette.text.secondary,
    fontSize: "0.875rem",
  },
  divider: {
    margin: theme.spacing(1, 0),
  },
  formContainer: {
    borderRadius: theme.shape.borderRadius,
    boxShadow: "none",
    border: `1px solid ${theme.palette.quizResults.headerBorder}`,
    backgroundColor: theme.palette.quizResults.form.backgroundColor,
  },
  accordionArrowWrapper: {
    display: "flex",
    justifyContent: "center",
    marginRight: theme.spacing(1),
  },
  accordionArrow: {
    transition: "transform 0.3s ease",
    transform: "rotate(0deg)",
  },
  expanded: {
    transform: "rotate(180deg)",
  },
  formHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    margin: theme.spacing(1, 0),
    borderRadius: theme.shape.borderRadius,
    "& .MuiAccordionSummary-content": {
      margin: "0 !important",
    },
  },
  formTitle: {
    flex: 1,
    fontSize: "1rem",
    fontWeight: 600,
  },
  formHeaderRight: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "center",
    gap: theme.spacing(1),
  },
  formStatus: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "0.85rem",
    fontWeight: 500,
  },
  formQuestions: {
    marginTop: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  questionBox: {
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.quizResults.headerBorder}`,
    backgroundColor: theme.palette.quizResults.question.backgroundColor,
    boxShadow: "none",
    "& .MuiAccordionSummary-content": {
      margin: "0 !important",
    },
  },
  questionHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 !important",
  },
  questionHeaderRight: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "center",
    width: "fit-content",
    gap: theme.spacing(1),
  },
  questionTitle: {
    fontSize: "0.95rem",
    fontWeight: 600,
    marginRight: theme.spacing(2),
    flex: 1,
  },
  correctAnswerLetter: {
    fontWeight: 600,
  },
  userAnswerLetter: {
    fontWeight: 600,
  },
  correctResult: {
    color: theme.palette.quizResults.correct.main,
    fontWeight: 600,
  },
  incorrectResult: {
    color: theme.palette.quizResults.incorrect.main,
    fontWeight: 600,
  },
  resultLabel: {
    fontWeight: 500,
    marginRight: theme.spacing(0.5),
  },
  resultStats: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "0.85rem",
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(1),
  },
  questionContent: {
    backgroundColor: theme.palette.quizResults.question.background,
    border: `1px solid ${theme.palette.quizResults.question.border}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
  },
  answersBox: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
    flex: 1,
  },
  selectedAnswerText: {
    fontSize: "0.875rem",
    border: `1px solid ${theme.palette.text.primary}`,
    fontWeight: 500,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0.5, 1),
    flex: 1,
    "& $answerStatus": {
      color: theme.palette.text.primary,
      fontWeight: 500,
    },
  },

  answerText: {
    fontSize: "0.875rem",
    color: theme.palette.text.primary,
    padding: theme.spacing(0.5, 1),
    flex: 1,
  },
  answerStatus: {
    fontSize: "0.875rem",
    float: "right",
  },
  correctAnswer: {
    fontSize: "0.875rem",
    border: `1px solid ${theme.palette.quizResults.correct.main}`,
    fontWeight: 500,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0.5, 1),
    flex: 1,
    "& $answerStatus": {
      color: theme.palette.quizResults.correct.main,
    },
  },
  incorrectAnswer: {
    fontSize: "0.875rem",
    border: `1px solid ${theme.palette.quizResults.incorrect.main}`,
    fontWeight: 500,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0.5, 1),
    flex: 1,
    "& $answerStatus": {
      color: theme.palette.quizResults.incorrect.main,
    },
  },
  noResultsContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    padding: theme.spacing(4),
  },
  noResultsText: {
    fontSize: "1rem",
    color: theme.palette.text.secondary,
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    padding: theme.spacing(4),
  },
  performancePercentage: {
    fontWeight: 600,
  },
  answerDate: {
    fontWeight: 500,
  },
  notAnsweredQuiz: {
    color: theme.palette.warning.main,
  },
  profileContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
}));
